export default __webpack_public_path__ + "static/media/react.d68d8e0b.jpg";